import {Component} from '@angular/core';
import {InBaseFrwComponent} from '../../inBaseFrwComponent';

@Component({
  selector: 'cmp-modal-header',
  template: `<div class="modal-header">
  <ng-content></ng-content>
</div>
`,
  styles: [``]
})
export class ModalHeaderComponent extends InBaseFrwComponent {

  constructor() {
    super();
  }

}
